/* The "+" menu between the cards on the Policies canvas: what each preset makes. */
import { DEFAULT_REFUSAL } from "./copy";

import type { RuleCreate, RuleWhen } from "../../types";

/** One of the "+" menu's starting points. A preset whose conditions start empty is made
    switched off — an empty `when` would match everyone, and writes apply at once — and goes on
    once its first condition holds someone. `starts` is the condition the editor opens on,
    empty (the server takes no empty condition); Blank opens on none. */
export interface Preset {
  label: string;
  hint: string;
  icon: "plus" | "ban" | "users" | "chat";
  body: Omit<RuleCreate, "agent_id" | "position">;
  starts?: keyof RuleWhen;
}

export const PRESETS: Preset[] = [
  { label: "Blank policy", hint: "Pick who it applies to yourself", icon: "plus", body: { name: "New policy", when: {}, action: "allow", enabled: false } },
  {
    label: "Keep out a domain", hint: "Competitors, or anyone you'd rather not serve", icon: "ban",
    body: { name: "Keep out", when: {}, action: "block", enabled: false, message: DEFAULT_REFUSAL }, starts: "people",
  },
  {
    label: "More for your team", hint: "Higher limits for people at your own domain", icon: "users",
    body: { name: "Your team", when: {}, action: "allow", enabled: false, message_limit: 60 }, starts: "people",
  },
  {
    label: "Limit chat apps", hint: "Their own budget and limits on WhatsApp, Telegram, Slack, Discord and Teams", icon: "chat",
    body: { name: "Chat apps", when: { channels: ["whatsapp", "telegram", "slack", "discord", "teams"] }, action: "allow", daily_budget_usd: 5, message_limit: 20 },
  },
];
